var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChannelTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5373 14.9755L11.3282 14.1074H6.67214L5.46312 14.9755C5.13124 15.3118 5.36784 15.887 5.83612 15.887H12.1642C12.6332 15.887 12.8684 15.3111 12.5373 14.9755Z",
    fill: "#4B4B4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2193 0.675781H1.78066C0.797344 0.675781 0 1.48299 0 2.47847V11.6859C0 12.6813 0.797344 13.4885 1.78066 13.4885H16.2193C17.2027 13.4885 18 12.6813 18 11.6859V2.47847C18 1.48299 17.2027 0.675781 16.2193 0.675781ZM8.16469 5.60442H7.13109V9.74686H5.78461V5.60442H4.74434V4.40679H8.16469V5.60442ZM11.4877 9.74686H10.0993L8.33871 4.40643H9.72L10.7814 8.15096H10.7986L11.867 4.40643H13.2553L11.4877 9.74686Z",
    fill: "#4B4B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelTv);
export default __webpack_public_path__ + "static/media/channel_tv.5cd0383550eabd0fecc773f7e2e0fdef.svg";
export { ForwardRef as ReactComponent };